export type WeeklyReportSelectableScope = 'selected_clients' | 'selected_fincas';

export interface WeeklyReportScopePayload {
  scopeType: WeeklyReportSelectableScope;
  clientIds: number[];
  fincaIds: number[];
  moduleIds: number[];
}

export function normalizeWeeklyReportIds(value: unknown): number[] {
  if (!Array.isArray(value)) {
    return [];
  }

  return value
    .map(id => Number(id))
    .filter(id => Number.isFinite(id));
}

export function normalizeWeeklyReportScopeType(
  scopeType: unknown
): WeeklyReportSelectableScope {
  return scopeType === 'selected_fincas' || scopeType === 'selected_modules'
    ? 'selected_fincas'
    : 'selected_clients';
}

export function getAuthorizedWeeklyReportFincas(
  fincas: any[],
  authorizedClientIds: number[]
): any[] {
  const clientIds = new Set(normalizeWeeklyReportIds(authorizedClientIds));

  return (fincas || []).filter(finca => {
    const clientId = Number(
      finca?.idCliente ?? finca?.cliente?.idCliente ?? finca?.client?.idCliente
    );
    return (
      clientIds.has(clientId) &&
      !finca?.isDeleted &&
      String(finca?.isDeleted) !== 'true'
    );
  });
}

export function getWeeklyReportFincaLabel(finca: any): string {
  const clientName = String(
    finca?.cliente?.name ?? finca?.client?.name ?? finca?.clientName ?? ''
  ).trim();
  const fincaName = String(finca?.name ?? finca?.fincaName ?? '').trim();
  return [clientName, fincaName].filter(Boolean).join(' - ');
}

export function buildWeeklyReportScopePayload(
  scopeType: string,
  clientIds: unknown,
  fincaIds: unknown
): WeeklyReportScopePayload {
  const normalizedScopeType = normalizeWeeklyReportScopeType(scopeType);
  return {
    scopeType: normalizedScopeType,
    clientIds:
      normalizedScopeType === 'selected_clients'
        ? normalizeWeeklyReportIds(clientIds)
        : [],
    fincaIds:
      normalizedScopeType === 'selected_fincas'
        ? normalizeWeeklyReportIds(fincaIds)
        : [],
    moduleIds: []
  };
}

export function hasWeeklyReportScopeSelection(
  scopeType: string,
  clientIds: unknown,
  fincaIds: unknown
): boolean {
  const payload = buildWeeklyReportScopePayload(scopeType, clientIds, fincaIds);
  return payload.scopeType === 'selected_clients'
    ? payload.clientIds.length > 0
    : payload.fincaIds.length > 0;
}
